import { useParams } from 'react-router-dom-v5'

export const useCampaign = () => {
  const { campaignID: pathnameCampaign } = useParams<{ campaignID?: string }>()
  return { campaignCodeFromUrl: pathnameCampaign || '' }
}
